const view = {
  props: {
    value: {
      type: Object,
      required: true
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: { ...this.value }
    }
  },
  watch: {
    value: {
      deep: true,
      handler (newVal) {
        this.selected = { ...newVal }
      }
    }
  },
  methods: {
    edit () {
      this.$emit('edit', this.selected)
    },
    closeDialog () {
      this.$emit('closed', true)
    }
  }
}

export default view
